import { defineMessages } from 'react-intl';

export default defineMessages({
    label: {
        id: '_.dashboard.action_buttons.make_repayment_label',
        defaultMessage: 'Make an early repayment'
    },
    shortLabel: {
        id: '_.dashboard.action_buttons.make_repayment_short_label',
        defaultMessage: 'Repay early'
    },
    overdueLabel: {
        id: '_.dashboard.action_buttons.make_repayment_overdue_label',
        defaultMessage: 'Make a repayment'
    },
    caption: {
        id: '_.dashboard.action_buttons.make_repayment_caption',
        defaultMessage: 'Repay any amount of your {balance} outstanding balance'
    },
    futureCaption: {
        id: '_.dashboard.action_buttons.make_repayment_future_caption',
        defaultMessage:
            'You can make early repayments here when you have an outstanding balance'
    },
    overdueCaption: {
        id: '_.dashboard.action_buttons.make_repayment_overdue_caption',
        defaultMessage: 'Repay overdue amount of {overdueAmount}'
    },
    coronaTitle: {
        id: '_.dashboard.action_buttons.coronavirus_title',
        defaultMessage: 'If you have trouble repaying, let us know.'
    },
    coronaSubTitle: {
        id: '_.dashboard.action_buttons.coronavirus_sub_title',
        defaultMessage:
            'There are lots of different {link}, please call us on {phoneNumber}.'
    },
    coronaWaysWeCanHelp: {
        id: '_.dashboard.action_buttons.ways_we_can_help',
        defaultMessage: 'ways we can help'
    },
    coronaPhoneNumber: {
        id: '_.dashboard.action_buttons.contact_number',
        defaultMessage: '020 3397 3375'
    }
});
